export default __webpack_public_path__ + "static/media/rewards-bg.93af88ab.png";